import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-video-simple',
  templateUrl: './video-simple.component.html',
  styleUrls: ['./video-simple.component.scss'],
})
export class VideoSimpleComponent implements OnInit {
  title = 'app-video-simple';

  ngOnInit(): void {}
}
